import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const WidgetLayoutModalWrapperStyle = styled.div`
  text-align: center;
  .control-manual-info {
    overflow: hidden;
    margin-bottom: 10px;

    // antd v5: span.anticon 태그
    .prev {
      float: left;
    }
    .next {
      float: right;
    }
    svg {
      font-size: 26px;
      cursor: pointer;
    }
  }
  .img-wrap {
    overflow-y: scroll;
    height: 535px;
    .amondz-img {
      width: 360px;
      border: 1px solid #adb5bd;
    }
  }
`;
